import { yup } from '@framework/validation/initYup.ts';
import { unionSchema } from '@framework/validation/union/unionSchema.ts';
import { ReferenceSchema } from '../../../../../expressions/validation/ReferenceSchema.ts';
import { AsyncServiceActionSchema } from './exec-async-service/AsyncServiceActionSchema.ts';
import { ButtonActionType, type IButtonAction } from './IButtonAction.ts';

export const ButtonActionSchema: yup.Lazy<IButtonAction> = unionSchema([
  yup.object({
    type: yup.string().exact(ButtonActionType.ListAdd).required(),
    listReference: ReferenceSchema.required().label('Widget Lista'),
  }),
  yup.object({
    type: yup.string().exact(ButtonActionType.ListRemove).required(),
    listReference: ReferenceSchema.required().label('Widget Lista'),
  }),
  AsyncServiceActionSchema,
  yup.object({
    type: yup.string().exact(ButtonActionType.SubsectionOpen).required(),
    subsectionReference: ReferenceSchema.required().label(
      'Widget Sottosezione',
    ),
  }),
]);

// TODO -> reinserire quando unionSchema funzionerà
// unionSchema([
//   yup.object({
//     type: yup.string().exact(ButtonActionType.ListAdd).required(),
//     widgetId: yup.string().required().label('Widget Lista')
//   }),
//   yup.object({
//     type: yup.string().exact(ButtonActionType.ListRemove).required(),
//     widgetId: yup.string().required().label('Widget Lista')
//   }),
//   yup.object({
//     type: yup.string().exact(ButtonActionType.ExecAsyncService).required(),
//     serviceId: yup.string().required().label('Servizio')
//   }),
//   yup.object({
//     type: yup.string().exact(ButtonActionType.SubsectionOpen).required(),
//     widgetId: yup.string().required().label('Widget Sottosezione')
//   })
// ]);
